import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LazySectionWrapperComponent } from './lazy-section-wrapper.component';

/**
 * Encapsulated feature module for LazySectionWrapperComponent, providing dynamic component chunk
 * loading, shimmer placeholders, and retry capability.
 */
@NgModule({
  imports: [
    CommonModule,
    MatButtonModule
  ],
  declarations: [
    LazySectionWrapperComponent
  ],
  exports: [
    LazySectionWrapperComponent
  ]
})
export class LazySectionWrapperModule {}
export { LazySectionWrapperComponent };
